import { Component, TemplateRef } from '@angular/core';
import { ToastService } from './toast.service';

@Component({
    selector: 'gea-toasts',
    template: `
    @for (toast of toastService.toasts(); track toast) {
      <ngb-toast
        [class]="toast.classname"
        (hidden)="toastService.remove(toast)"
        [autohide]="toast.delay === 0 ? false : true"
        [delay]="toast.delay || 50000000"
        >
        <div class="left">
          @if (toast.classname == 'success') {
            <svg xmlns="http://www.w3.org/2000/svg" fill="#008e43" viewBox="0 0 16 16">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
            </svg>
          }
          @if (toast.classname == 'info') {
            <svg xmlns="http://www.w3.org/2000/svg" fill="#DED8D3" viewBox="0 0 16 16">
              <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
            </svg>
          }
          @if (toast.classname == 'error') {
            <svg xmlns="http://www.w3.org/2000/svg" fill="#E44040" viewBox="0 0 16 16">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
            </svg>
          }
        </div>
        <div class="right">
          @if (isTemplate(toast)) {
            <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
          } @else {
            {{ toast.textOrTpl }}
          }
        </div>
        <svg class="close" (click)="this.onClose(toast)" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
          <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
        </svg>
      </ngb-toast>
    }
    `,
    host: { 'class': 'toast-container position-fixed top-0 end-0 p-3', 'style': 'z-index: 1200' },
    standalone: false
})
export class ToastsContainer {
  constructor(public toastService: ToastService) {}

  onClose(t: string) {
    this.toastService.remove(t)
  }
  isTemplate(toast: any) { return toast.textOrTpl instanceof TemplateRef }
}
